import React, { FunctionComponent } from 'react';
import { Button } from '../../atoms/button';
import type { Props as ComponentProps } from './types';
import { LoginModal } from '../../organisms/loginModal';
import { RegisterModal } from '../../organisms/registerModal';

type Props = ComponentProps & {
  followed: boolean;
  followers: number;
  followValue: string;
  isShow: boolean;
  classNames: {
    click: string;
    clicked: string;
    num: string;
  };
  isLoginModalOpen: boolean;
  isRegisterModalOpen: boolean;
  redirectUrl: string;
  handleClick: () => void;
  handleToggleLoginModal: () => void;
  handleToggleRegisterModal: () => void;
  handleChangeModal: (from: "login" | "register") => void;
  isRecruitmentOrEventOrTvOrCompanyPath: () => boolean;
};

export const Presentation: FunctionComponent<Props> = (props) => {
  return (
    <>
      <div className={props.className}>
        <Button
          className={`${props.followed ? props.classNames.clicked : props.classNames.click} gtm-follow-view-count`} // followed 状態に応じてクラスを決定し、gtm-follow-view-countを追加
          onClicked={props.handleClick}
          data-event-name='follow on screen'
          defaultValue={props.followValue}
        />
        <span className={`${props.classNames.num} ${props.isShow ? 'is-hide' : '' }`}>
          {props.followers}
          <span>フォロワー</span>
        </span>
      </div>
      <LoginModal
        isModalOpen={props.isLoginModalOpen}
        redirectUrl={props.redirectUrl}
        fromButton="follow"
        handleToggleLoginModal={props.handleToggleLoginModal}
        handleChangeModal={props.handleChangeModal}
        lineIcon={props.lineIcon}
      />
      <RegisterModal
        isModalOpen={props.isRegisterModalOpen}
        redirectUrl={props.redirectUrl}
        isRequestPathRecruitmentOrEventOrTvOrFollow={props.isRecruitmentOrEventOrTvOrCompanyPath()}
        isCarefully={false}
        handleToggleRegisterModal={props.handleToggleRegisterModal}
        handleChangeModal={props.handleChangeModal}
        lineIcon={props.lineIcon}
      />
    </>
  );
};
